// hooks/useAuth.js
import { useContext } from 'react';
import { AuthContext } from '../App';

export const useAuth = () => {
  const context = useContext(AuthContext);
  
  if (!context) {
    throw new Error('useAuth must be used within an AuthProvider');
  }
  
  return context;
};

// Custom hook for permission checking
export const usePermissions = () => {
  const { permissions, hasPermission, hasRole, user } = useAuth();
  
  return {
    permissions,
    hasPermission,
    hasRole,
    user,
    isOwner: user?.role === 'owner',
    isEmployee: user?.role === 'employee',
    canAccessPortfolio: (item) => hasPermission('portfolio', item),
    canAccessProduce: (item) => hasPermission('produce', item),
    canAccessBilling: (item) => hasPermission('billing', item)
  };
};